import { subscription } from '../../actions/types';

const initialState = {
  type: '',
  message: ''
};

function setFeedbackToast (type, message) {
  return {
    type,
    message
  };
}

const feedbackToastReducer = (state = initialState, action) => {
  if (!action.errors) {
    switch (action.type) {
      case subscription.SUBSCRIBE_TO_NEWSLETTER:
        return setFeedbackToast('success', action.payload.message);
      default:
        return initialState;
    }
  } else {
    switch (action.type) {
      case subscription.SUBSCRIBE_TO_NEWSLETTER:
        return setFeedbackToast('error', action.errors);
      default:
        return setFeedbackToast('error', 'Operation Failed');
    }
  }
};

export { feedbackToastReducer };
